import React from "react";
import { FieldProps, useField } from "formik";
import { ToggleSwitchInput, ToggleSwitchInputProps } from "elements";

export type CheckboxProps = Omit<
  ToggleSwitchInputProps,
  keyof FieldProps["field"]
> & {
  name: string;
  checked?: boolean;
};
export const ToggleSwitch: React.FC<CheckboxProps> = props => {
  const [{ onChange, value }] = useField(props.name);
  return (
    <ToggleSwitchInput
      checked={props.checked ?? value ?? false}
      onChange={onChange}
      disabled={props.disabled}
      {...props}
    />
  );
};
